import React from 'react';
import { useAuth } from '../context/AuthContext';
import Login from './Login';
import SessionStatus from './SessionStatus';
import AgencySettings from './backoffice/AgencySettings';
import AgencySupervisor from './backoffice/AgencySupervisor';

export default function AgencyPreviewApplication() {
    const { token, agentInfo, loading, sessionError, retrySession, login, logout } = useAuth();
    if (loading || sessionError) return <SessionStatus loading={loading} error={sessionError} onRetry={retrySession} onLogout={logout} />;
    if (!token) return <Login microsoftOnly onLoginSuccess={login} />;
    const permissions = agentInfo?.permissions || {};
    if (permissions.agency_scope || permissions.capabilities?.includes('agency_supervisor')) return <AgencySupervisor />;
    return <main className="min-h-screen bg-slate-950 p-8 text-slate-100">
        <header className="mb-8 flex justify-between gap-4"><h1>Pre · Supervisión de agencias · Pruebas internas</h1>
            <button onClick={logout}>Cerrar sesión</button></header>
        {permissions.capabilities?.includes('backoffice') ? <AgencySettings /> : <p>Tu usuario no tiene acceso a la configuración de agencias.</p>}
    </main>;
}
